module.exports = __webpack_public_path__ + "static/media/step-1.873fc6e7.png";